import { Subject } from 'rxjs';
import * as i0 from "@angular/core";
var PmadminService = /** @class */ (function () {
    function PmadminService() {
        this.userChangeSuccess = new Subject();
        this.newUserPopup = new Subject();
        this.openEditPopup = new Subject();
        this.userId = '';
    }
    PmadminService.prototype.queueSuccessMessage = function () {
        this.userChangeSuccess.next();
    };
    PmadminService.prototype.getSuccessMessage = function () {
        return this.userChangeSuccess.asObservable();
    };
    PmadminService.prototype.closeNewUserPopup = function () {
        this.newUserPopup.next();
    };
    PmadminService.prototype.getCloseNewUserPopup = function () {
        return this.newUserPopup.asObservable();
    };
    PmadminService.prototype.openEdit = function () {
        this.openEditPopup.next();
    };
    PmadminService.prototype.getOpenEditPopup = function () {
        return this.openEditPopup.asObservable();
    };
    PmadminService.prototype.setUserId = function (userId) {
        this.userId = userId;
    };
    PmadminService.prototype.getUserId = function () {
        return this.userId;
    };
    PmadminService.ngInjectableDef = i0.defineInjectable({ factory: function PmadminService_Factory() { return new PmadminService(); }, token: PmadminService, providedIn: "root" });
    return PmadminService;
}());
export { PmadminService };
